import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { ReactNode } from "react";

export type PageHeaderProps = {
  title: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
  className?: string;
};

export function PageHeader({
  title,
  subtitle,
  actions,
  className,
}: PageHeaderProps) {
  return (
    <Stack
      className={className}
      direction="row"
      alignItems="flex-start"
      justifyContent="space-between"
      flexWrap="wrap"
      useFlexGap
      spacing={2}
      sx={{ mb: 2.5 }}
    >
      <Box sx={{ minWidth: 0, flex: "1 1 auto" }}>
        <Typography
          variant="h4"
          component="h1"
          className="title"
          sx={{
            mb: 0,
            fontSize: { xs: "1.35rem", md: "1.5rem" },
            fontWeight: 600,
            letterSpacing: "-0.02em",
            lineHeight: 1.25,
            color: "text.primary",
          }}
        >
          {title}
        </Typography>
        {subtitle != null && (
          <Box
            sx={{
              mt: 0.5,
              maxWidth: 900,
              lineHeight: 1.45,
              color: "text.secondary",
              typography: "body2",
            }}
          >
            {subtitle}
          </Box>
        )}
      </Box>
      {actions != null && (
        <Stack
          direction="row"
          alignItems="center"
          flexWrap="wrap"
          useFlexGap
          spacing={1}
          sx={{ flex: "0 0 auto", pt: 0.25 }}
        >
          {actions}
        </Stack>
      )}
    </Stack>
  );
}

export default PageHeader;
